import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetSiteVisitsFromComplianceInvestigationFetchUrl,
  GetSiteVisitsFromLicenseeReturnFetchUrl,
  GetSiteVisitsFromNonComplianceFetchUrl,
  ISiteVisit,
} from "../../api/ISiteVisit";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { SiteVisitsGridProps } from "./SiteVisitsGridProps";

const GetUrlForSiteVisit = (siteVisit: ISiteVisit) => {
  return `/licence-profile/${siteVisit.profile_number}/compliance/sitevisit/${siteVisit.sitevisitid}`;
};

const SiteVisitsGrid = ({
  regardingObjectId,
  regardingObjectType,
}: SiteVisitsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (regardingObjectType) {
        case "CI":
          return GetSiteVisitsFromComplianceInvestigationFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Non Compliance":
          return GetSiteVisitsFromNonComplianceFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Licensee Return":
        default:
          return GetSiteVisitsFromLicenseeReturnFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(regardingObjectId);

  const tableColumnsBig: Column<Record<string, ISiteVisit>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Site Visit")}</span>
            </td>
            <td>
              <Link to={GetUrlForSiteVisit(rowInfo.row.original)}>
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Visit Date",
      accessor: "visit_date",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Visit Type",
      accessor: "visit_type",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Visit Title",
      accessor: "subject",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISiteVisit>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Site Visit")}</span>
            </td>
            <td>
              <Link to="">{rowInfo.value}</Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Visit Title",
      accessor: "subject",
      Filter: false,
    },
  ];
  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { SiteVisitsGrid };
